import React from 'react'
import { ArticleCardMode } from 'experiences/learn/articles/ArticleCard/types'
import { GridContainerProps, GridItem, MasonryGridItem } from 'experiences/learn/articles/ArticleGrid/styles'

export type ArticleGridMode = 'mini' | 'standard' | 'mixed'

interface Config {
	Component: React.FC<React.PropsWithChildren<unknown>>
	cardMode: ArticleCardMode
	gridProps: GridContainerProps
}

export const configs: Record<ArticleGridMode, Config> = {
	mini: {
		Component: GridItem,
		cardMode: 'mini',
		gridProps: { articleCardHeight: 320, columnCount: 4, articleCardWidth: 301 }
	},
	standard: {
		Component: GridItem,
		cardMode: 'responsive',
		gridProps: { articleCardHeight: 360, columnCount: 3, articleCardWidth: 320 }
	},
	mixed: {
		Component: MasonryGridItem,
		cardMode: 'responsive',
		gridProps: { articleCardHeight: 360, columnCount: 3, articleCardWidth: 320 }
	}
}
